import React from 'react'

import LeaveModal from '../LeaveModal/LeaveModal'
import { InviteModal } from '../../../../components/InviteModal/InviteModal'

import { HeaderWrap, LinksWrap, ProgressGroup, Button } from './styled'

import { HintText } from 'src/components/Typography'
import { ProgressBar } from 'src/components/ProgressBar'
import { InviteIcon, CloseIcon } from 'src/components/Icons'
import { breakpoints } from 'src/styles/media'
import { useMedia } from 'src/hooks/useMedia'
import { LogoLink } from 'src/components/LogoLink/LogoLink'

interface HeaderProps {
  progress: number
  quizTitle: string
  leaveModalOpen: boolean
  setLeaveModalOpen: (isOpen: boolean) => void
  inviteModalOpen: boolean
  setInviteModalOpen: (isOpen: boolean) => void
}

const Header: React.FC<HeaderProps> = ({
  progress,
  quizTitle,
  leaveModalOpen,
  setLeaveModalOpen,
  inviteModalOpen,
  setInviteModalOpen,
}) => {
  const isDesktop = useMedia(breakpoints.desktop)

  return (
    <>
      <HeaderWrap>
        {isDesktop ? (
          <LogoLink />
        ) : (
          <Button onClick={() => setLeaveModalOpen(true)}>
            <CloseIcon />
          </Button>
        )}
        <ProgressGroup>
          <HintText>{quizTitle}</HintText>
          <ProgressBar progress={progress} />
        </ProgressGroup>
        <LinksWrap>
          <Button onClick={() => setInviteModalOpen(true)}>
            <InviteIcon />
          </Button>
          {isDesktop && (
            <Button onClick={() => setLeaveModalOpen(true)}>
              <CloseIcon />
            </Button>
          )}
        </LinksWrap>
      </HeaderWrap>
      <LeaveModal
        isOpen={leaveModalOpen}
        onClose={() => setLeaveModalOpen(false)}
      />
      <InviteModal
        isOpen={inviteModalOpen}
        onClose={() => setInviteModalOpen(false)}
      />
    </>
  )
}

export default Header
